<div class="flex flex-row items-center hover:cursor-pointer hover:opacity-70" [ngClass]="{'preview-text': disabled}">
  <tandem-icon [icon]="navItem.icon" [width]="30" [height]="30" [ngClass]="{'preview-text opacity-70': disabled}" color="white"></tandem-icon><tandem-tooltip [text]="navItem.label"></tandem-tooltip>
  <h5 class="ms-15 text-background" *ngIf="isExpanded" [ngClass]="{'preview-text opacity-70': disabled}">{{navItem.label}}</h5>
</div>
